const TDK: Record<string, any> = {
  // 首页
  home: {
    title: '小鱼易连_视频会议_远程会议_超融合云视频会议系统_政府/企业数字化转型服务商',
    desc: '云视频、超融合云视频、视频会议、远程会议、视频会议系统、企业数字化转型',
    keyword:
      '小鱼易连创新打造“高安全·超融合·全连接”云视频会议，远程会议系统，专注为党政军央企，金融，学校，医院等大型组织及企业提供超融合视讯协作应用服务，领先通过等保三级+可信云双认证，实现国密算法端到端全链路加密。',
  },
  // 云视频会议
  product: {
    title: '小鱼易连_云视频会议系统_远程会议软件',
    desc: '小鱼易连打造“高安全·超融合·全连接”云视频会议系统,专注为党政军央企等大型组织及企业提供超融合视讯协作应用服务,领先通过等保三级+可信云双认证,实现国密算法端到端全链路加密。',
    keyword: '视频会议系统，视频会议软件，远程会议系统',
  },
  // 云视频平台
  productPlatform: {
    title: '小鱼易连_云视频平台',
    desc: '小鱼易连超融合云视频平台，通过统一的软件定义架构和安全设计，打造统一的支撑开发平台，保证视频会议、直播、点播、监控的融合互通，为全行业用户带来高品质的音视频体验。',
    keyword: '云视频平台',
  },
  // 智能硬件
  hardware: {
    title: '小鱼易连_云视频会议智能硬件_远程会议智能硬件',
    desc: '小鱼易连提供满足全场景应用的云视频会议智能硬件，包括大中小、室内外多场景终端，支持政务内外网、行业专网、互联网、4G/5G、卫星网等多网络灵活接入，实现个性化业务应用。',
    keyword: '云视频会议智能硬件',
  },
  // H.323硬件会议
  h323hardware: {
    title: '小鱼易连_H.323硬件会议_远程会议',
    desc: '小鱼易连H.323硬件会议，支持H.323/SIP标准，为传统H.323/SIP产品提供云视频体验，兼容异构品牌视频会议。',
    keyword: 'H.323硬件会议',
  },

  // 软件客户端
  productClient: {
    title: '小鱼易连_云视频会议软件客户端',
    desc: '小鱼易连云视频会议软件客户端，适用于Windows、Mac、iOS/Android客户端音视频互动、内容共享、会议主持、直播、录制、点播等功能。',
    keyword: '云视频会议软件客户端',
  },
  // 指挥调度客户端
  commandDispatch: {
    title: '小鱼易连_云视频会议指挥调度客户端',
    desc: '小鱼易连云视频会议指挥调度客户端，用于管理员或指挥调度人员进行专业会议管理、综合视频调度，可对内部所有会议或会场进行监管，并对接监控平台构建一体化的会议与监控融合调度平台。',
    keyword: '云视频会议指挥调度客户端',
  },
  // 未来教育
  education: {
    title: '小鱼易连_未来教育',
    desc: '小鱼易连面向未来教育，打造教育全融合视频互动解决方案，借助统一教育视频应用平台，实现互动、直播、点播、资源分享、教学管理、AI智能等多场景融合应用，促进教育均衡发展。',
    keyword: '未来教育',
  },
  // 教育视频能力中枢
  videoCenter: {
    title: '小鱼易连_教育视频能力中枢_未来教育',
    desc: '小鱼易连教育视频能力中枢，以核心云视频技术优势，实现高清流畅的音视频交互体验，为学校、教师、学生提供专业的音视频云服务，打破地区教育发展瓶颈，助力教育公平和均衡发展。',
    keyword: '教育视频能力中枢',
  },
  // 教育资源管理平台
  educationPlatform: {
    title: '小鱼易连_教学管理与资源平台_未来教育',
    desc: '小鱼易连教学管理与资源平台是支撑互动课堂的核心教学平台，包含云录播和直播、协同备课、远程教研、在线督导、教学运维、数据分析、资源汇聚、资源管理等多应用。',
    keyword: '教学管理与资源平台',
  },
  // 智能互动教学终端
  educationTerminal: {
    title: '小鱼易连_智能视频互动教学终端_未来教育',
    desc: '小鱼易连智能互动教学终端，以云视频技术为核心，以教学业务为指导，帮助教育用户轻松实现课程资源建设、三个课堂、网络教研、教育直播、家校互动的常态化应用，助力教育资源优质均衡。',
    keyword: '智能互动教学终端',
  },
  // 小鱼易连开发平台
  api: {
    title: '小鱼易连_开发平台',
    desc: '小鱼易连打造具备业务和场景创新能力、支持API和SDK定制化接入的泛业务开发平台，是可视数字化新连接广泛完善和不断深化的创新支撑。',
    keyword: '开发平台',
  },
  // 互动音视频
  apiAv: {
    title: '小鱼易连_互动音视频',
    desc: '小鱼易连提供全平台SDK及API接口，能与主流的办公协同应用对接和集成，提供安全、稳定、高清的互动音视频服务，适用协同办公、在线教育、金融双录、视频客服、远程医疗等应用。',
    keyword: '互动音视频',
  },
  // 多方会议调度
  apiDispatch: {
    title: '小鱼易连_多方会议调度',
    desc: '小鱼易连通过与各种指挥调度、业务管理、可视化等系统进行快速对接和集成，提供多方会议调度能力，广泛应用于会议会商、指挥调度、指挥党建、远程调解、互动培训等应用场景。',
    keyword: '多方会议调度',
  },
  // 互动会议直播
  apiLive: {
    title: '小鱼易连_互动会议直播',
    desc: '小鱼易连互动会议直播，通过易用的直播和录播API接口集成，可以快速实现大型活动、远程培训、企业年会、智慧党建、营销活动的直播或点播应用，单场并发规模可达百万级。',
    keyword: '互动会议直播',
  },
  // 教育api产品
  apiEducation: {
    title: '小鱼易连_教育API产品',
    desc: '小鱼易连教育API产品，接口功能覆盖引擎管理、课程及用户管理、音视频通话质量管理及课内外应用状态监测等全业务流程，可协助客户快速完成从前端教学应用到运维及后台管理的完整业务体系开发。',
    keyword: '教育API产品',
  },

  // 政务行业
  govSolution: {
    title: '小鱼易连_政府服务行业云视频会议解决方案',
    desc: '小鱼易连提供自主创新云视频技术和政务云视频顶层设计方案，将云视频应用从会议室延展到个人互联、移动接入、融合调度、政务服务等多场景，全面提升政务数字化水平，助力政府数字化转型。',
    keyword: '政府服务行业云视频会议解决方案',
  },
  //政法行业
  govLow: {
    title: '小鱼易连_智慧政法行业数字化解决方案',
    desc: '小鱼易连通过构建一体化“智慧政法”全融合云视频平台，促进司法行政效率和公共法律服务水平提升，助力执法规范化、管理精细化、服务透明化，推进法治现代化建设。',
    keyword: '智慧政法行业数字化解决方案',
  },
  // 企业集团
  group: {
    title: '小鱼易连_企业集团行业智能云会议/协同办公解决方案',
    desc: '小鱼易连通过“高安全·超融合·全连接”的云视频整体解决方案，深度融合企业集团业务需求，可高效支撑企业远程会议、协同办公、视频客服等日常或定制场景应用，赋能企业集团数字化转型升级。',
    keyword: '企业集团行业智能云会议解决方案，企业集团行业协同办公解决方案',
  },
  // 金融行业
  finance: {
    title: '小鱼易连_金融行业数字化转型解决方案',
    desc: '小鱼易连以“数字化、科技引领、创新驱动”为整体布局驱动，为金融行业提供安全、便捷的云视频中台服务，适应金融业务需求和网络条件灵活部署，助力金融机构实现管理数字化、科技化、智能化。',
    keyword: '金融行业数字化转型解决方案',
  },
  // 教育行业
  eduSolution: {
    title: '小鱼易连_教育行业解决方案',
    desc: '教育全融合视频互动解决方案，以云视频互动技术为核心，实现互动教学、同步课堂、远程教研、督导巡课、视频会议、考场监控、校园安全等智慧教育场景的融合应用，为教育用户构建教、学、研、管、评及组织办公协同的一站式音视频应用生态体系，促进教育优质均衡，实现“蓝天下·同课堂”。',
    keyword: '教育行业解决方案',
  },
  // 医疗行业
  medical: {
    title: '小鱼易连_医疗行业分级诊疗解决方案',
    desc: '小鱼易连通过整合业务系统为远程医疗提供数据及流程支撑，打造全流程、全网络、全场景、全贯通、全业务的远程医疗平台，帮助患者实现远程就医，提升基层医生医疗水平，提高医疗救治服务效率，推动基层医疗发展，促进分级诊疗，优化医疗资源配置，创新互联网医院发展模式，推动区域医疗协同发展。',
    keyword: '医疗行业分级诊疗解决方案',
  },
  //水利行业
  waterConservancy: {
    title: '小鱼易连_水利行业智慧水利解决方案',
    desc: '小鱼易连打造集水利会议系统、监控系统、单兵系统、指挥车等于一体的音视频集控系统，满足大规模、多场景、广覆盖、全业务嵌入的内外部高清视频沟通需求，赋能数字孪生水利工程建设，助力水利治理、防汛抗旱等日常智慧管理。',
    keyword: '水利行业智慧水利解决方案',
  },
  //应急行业
  emergency: {
    title: '小鱼易连_应急行业云视频解决方案',
    desc: '小鱼易连采用云计算与虚拟化技术，构建一体化“应急指挥融合平台”，通过标准音视频通信协议与各级单位、部门机构的视频系统实现互通互联，实现全时空、多部门、多业务的视频协同，让应急指挥直达一线，加快推进应急管理体系现代化。',
    keyword: '应急行业云视频解决方案',
  },

  // 法院
  court: {
    title: '小鱼易连_法院视频会议解决方案',
    desc: '小鱼易连法院视频会议解决方案，通过“高安全·超融合·全连接”云视频，可实现互联网庭审、多方协调、一乡一庭、移动法庭、庭审直播、远程庭审等，让司法程序高效便捷。',
    keyword: '法院视频会议解决方案',
  },
  // 检察院
  procuratorate: {
    title: '小鱼易连_检察院视频会议解决方案',
    desc: '小鱼易连检察院视频会议解决方案，通过“高安全·超融合·全连接”云视频，高效实现检法协同、远程汇报、分析讲座、远程提审、三方提审等多场景应用，实现检务工作智慧化。',
    keyword: '检察院视频会议解决方案',
  },
  // 税务
  tax: {
    title: '小鱼易连_税务视频会议解决方案',
    desc: '小鱼易连税务视频会议解决方案，依托“高安全·超融合·全连接”云视频技术，实现多级会议、在线交流、纳服协作、数据管税、税务普法等应用。',
    keyword: '税务视频会议解决方案',
  },
  // 远程办公
  telecommuting: {
    title: '小鱼易连_企业远程办公视频会议解决方案',
    desc: '小鱼易连提供远程办公视频会议解决方案，员工使用PC/Mac、手机，通过家庭宽带或4G网络就能实现多方高清会议，可共享Word、PPT、Excel等各种文档，会后还可生成音视频记录。',
    keyword: '企业远程办公视频会议，远程办公视频会议解决方案',
  },
  // 在线课堂
  onlineTeaching: {
    title: '小鱼易连_在线课堂视频会议解决方案',
    desc: '小鱼易连在线课堂视频会议解决方案，助力停课不停学。在社会应急或特殊时期，老师可在校使用专业云视频硬件终端或在家使用电脑授课，学生在家用电脑、平板或手机上课，可实时双向交流。',
    keyword: '在线课堂视频会议解决方案',
  },

  // 交通行业
  traffic: {
    title: '小鱼易连_交通行业视频会议远程会议解决方案',
    desc: '小鱼易连交通行业视频会议解决方案，以“高安全·超融合·全连接”的云视频技术，助力交通行业信息化建设，满足视频沟通、应急处理、统一调度、综合执法、巡查巡检等业务应用需求。',
    keyword: '交通行业视频会议解决方案',
  },
  // 核心优势
  advantage: {
    title: '小鱼易连_远程视频会议核心优势',
    desc: '小鱼易连远程视频会议核心优势业内领先，超大规模的运营级云视频平台、AI智能超高清会议、领先“SVC+AVC”双引擎架构、全面自主安全可靠。',
    keyword: '远程视频会议核心优势',
  },
  // 公司新闻
  news: {
    title: '小鱼易连_视频会议新闻资讯_让世界零距离',
    desc: '小鱼易连创新打造“高安全·超融合·全连接”云视频,专注为党政军央企等大型组织及企业提供超融合视讯协作应用服务，实时更新视频会议新闻资讯。',
    keyword: '视频会议新闻资讯',
  },
  // 三个课堂
  threeClass: {
    title: '小鱼易连_三个课堂',
    desc: '小鱼易连三个课堂解决方案采用“云+硬件终端+开发平台+AI“整体架构，连接区域内、区域间优质校和薄弱校，为全体师生构建高质量的学习、教研、培训和交流的平台与通道。咨询热线：400-900-3567。',
    keyword: '三个课堂',
  },
  //超融合视频平台
  platform: {
    title: '小鱼易连_超融合云视频平台解决方案',
    desc: '超融合云视频平台解决方案',
    keyword: '小鱼易连采用新一代智能云化架构和先进的音视频算法，功能丰富，性能强大，部署灵活，易管易用，为用户提供安全、稳定、高品质的音视频体验。',
  },
};

export const getTdk = (key: string) => {
  if (!TDK[key]) return TDK['home'];
  return TDK[key];
};
